import * as React from "react";
import { connect } from "react-redux";

import { TopLink } from "../../..";

function BackLink({ classes, history, household, advisorId, pathname }) {
  const householdView = pathname.includes("/Portal/admin/household/");
  const portfolioView = householdView && pathname.includes("/portfolio");

  if (!(householdView && household && household.householdDetail)) {
    return null;
  }

  if (portfolioView) {
    return (
      <TopLink
        path={`/Portal/admin/household/${household.householdDetail.id}`}
        text="Back to Household"
      />
    );
  } else {
    return (
      <TopLink
        path={`/Portal/admin/advisor/${
          advisorId || household.householdDetail.advisors[0].id
        }`}
        text="Back to Advisor Book"
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    household: state.household,
  };
};

export default connect(mapStateToProps)(BackLink);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/AdminNavigation/components/BackLink/index.jsx